// extracted by mini-css-extract-plugin
export default {"reminder":"ReminderManagerModal_reminder__T-Gpq","modal":"ReminderManagerModal_modal__CTV-1","button":"ReminderManagerModal_button__IqOTx"};